var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeBars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8491 25.9974H27.8486C27.4783 25.9992 27.1088 26.0011 26.7488 25.9993H25.0119V9.771e-06H25.3156H28.8169L29.1532 0V25.9969C28.727 25.9931 28.2876 25.9952 27.8492 25.9974H27.8492H27.8491ZM0 19.4943L0.430304 19.4906L0.431727 19.4906C1.12186 19.4846 1.81003 19.4786 2.49923 19.4754H4.14059V25.9992H3.63828H0.268005L0.00227746 25.9992L0 19.4943ZM18.5638 3.99985V25.9992H22.4155V3.99985H18.5638ZM16.6379 25.9993H12.7862V8.99979H16.6379V25.9993ZM6.04562 25.9993H10.8603V14.9996H6.04562V25.9993Z",
    fill: "url(#paint0_linear_269_855)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_855",
    x1: 29.1509,
    y1: 11.9739,
    x2: 2.02028,
    y2: 11.2451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.394082,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535404,
    stopColor: "#FEA401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80027,
    stopColor: "#FF5A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4101"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeBars);
export default __webpack_public_path__ + "static/media/threeBars.ad03dd53bf10fccb4075b12970630d5b.svg";
export { ForwardRef as ReactComponent };